import { init, locale, _, register } from 'svelte-i18n';

register('en', () => import('lang/en.json'));
register('ar', () => import('lang/ar.json'));
register('fr', () => import('lang/fr.json'));

function setupI18n(locale = 'en') {
	return init({
		initialLocale: locale,
		fallbackLocale: 'en',
	});
}

export { _, locale, setupI18n };
